// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout-module__Layout___2voYf","layout":"Layout-module__Layout___2voYf"};